module.exports = __webpack_public_path__ + "static/media/lamp.ff1d21a1.svg";